var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodAcceptanceOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1L16.3063 11.5029C18.4644 15.4068 15.3258 20 10.5 20C5.67424 20 2.53557 15.4068 4.69371 11.5029L10.5 1Z",
    fill: "url(#paint0_linear_4097_7140)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99988 14.5698L8.65526 16.4419C8.84334 16.6546 9.17057 16.6682 9.37564 16.4719L14.0458 12",
    stroke: "white",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4097_7140",
    x1: 10.5007,
    y1: 1,
    x2: 10.5007,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A40101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0303"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodAcceptanceOn);
export default __webpack_public_path__ + "static/media/BloodAcceptanceOn.c1c7565fe7a6e4227f59b1af77fc2dfe.svg";
export { ForwardRef as ReactComponent };